import { HttpParams } from '@angular/common/http';
import { appendHttpParamsFromObject } from 'shared/util-common';

import { Pagination, GuidelineReview } from '@treetop/shared/model';

import { GuidelineGetOptions, GuidelineReviewDto } from './guidelines.http.service';

export const createGuidelineParams = (pagination: Pagination, options?: GuidelineGetOptions): HttpParams => {
  let params = new HttpParams();

  params = appendHttpParamsFromObject(pagination, params);

  if (options?.filter) {
    const mappedFilter = {
      ownerIds: options.filter.owners?.map((owner) => owner.id),
      authorIds: options.filter.authors?.map((author) => author.id),
      organizationIds: options.filter.organizationIds,
      guidelineStates: options.filter.guidelineStates,
      searchText: options.filter.searchText,
      showExpired: options.filter.showExpired,
      showSharedGuidelines: options.filter.showSharedGuidelines,
      showImportedGuidelines: options.filter.showImportedGuidelines,
      showSoonToExpire: options.filter.showSoonToExpire,
      taxonomyIds: options.filter.taxonomyIds,
      resourceTagIds: options.filter.resourceTags?.map((tag) => tag.id),
    };

    params = appendHttpParamsFromObject(mappedFilter, params);
  }

  options?.sorting && (params = params.append('field', options.sorting.field));
  options?.sorting && (params = params.append('order', options.sorting.order));
  if (options?.usableOnly !== undefined) {
    params = params.append('usableOnly', options.usableOnly.toString());
  }

  return params;
};

export const createGuidelineDetailParams = (): HttpParams => {
  let params = new HttpParams();

  // TODO: Check here for the parameter, if it could be used in an enum.
  params = params.append('isBaseForNewItem', false);

  return params;
};

export const createActivityStreamParams = (allVersions: boolean, fromDate?: Date, toDate?: Date): HttpParams => {
  let params = new HttpParams();

  params = params.append('allVersions', allVersions.toString());

  if (fromDate) {
    params = params.append('fromDate', fromDate.toISOString());
  }

  if (toDate) {
    params = params.append('toDate', toDate.toISOString());
  }

  return params;
};

export const mapGuidelineReviewToDto = (review: GuidelineReview): GuidelineReviewDto => {
  return {
    ...review,
    updatedAt: review.updatedAt.toDateString(),
    assignedAt: review.assignedAt.toDateString(),
    unAssignedAt: review.unAssignedAt.toDateString(),
    guidelineReviewActivities: review.guidelineReviewActivities.map((activity) => ({
      id: activity.id,
      status: activity.status,
      updatedAt: activity.updatedAt.toDateString(),
    })),
  };
};

export const mapDtoToGuidelineReview = (dto: GuidelineReviewDto): GuidelineReview => {
  return {
    ...dto,
    updatedAt: new Date(dto.updatedAt),
    assignedAt: new Date(dto.assignedAt),
    unAssignedAt: dto.unAssignedAt ? new Date(dto.unAssignedAt) : undefined,
    guidelineReviewActivities: dto.guidelineReviewActivities.map((activity) => ({
      id: activity.id,
      status: activity.status,
      updatedAt: new Date(activity.updatedAt),
    })),
  };
};
